import { Alert, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import FormTemplateEditor from "~/modules/settings/shared/formTemplateEditor/components/FormTemplateEditor";
import { useSettingsFormTemplateEditorData } from "~/modules/settings/shared/formTemplateEditor/hooks/useSettingsFormTemplateEditorData";

import { SettingsMasterFormRoute_GetByTypeDocument } from "../../queries.generated";
import useSettingsMasterFormRoute_GetByType from "./api/useSettingsMasterFormRoute_GetByType";
import { toMasterFormType } from "./util/toMasterFormType";

export default function MasterFormRoute() {
    const { t } = useTranslation("masterForms");

    const { masterFormType } = useParams();
    if (!masterFormType) throw Error("no masterFormType param in url");

    const type = toMasterFormType(masterFormType);

    const { masterForm, loading, error } = useSettingsMasterFormRoute_GetByType(type);

    const {
        addFormTemplateQuestionMutation,
        updateFormTemplateQuestionMutation,
        deleteFormTemplateQuestionMutation,
        handleAddQuestion,
        handleUpdateQuestion,
        editQuestionError,
    } = useSettingsFormTemplateEditorData({
        refetchQueries: [
            {
                query: SettingsMasterFormRoute_GetByTypeDocument,
                variables: { type },
            },
        ],
        formTemplateId: masterForm?.settingsFormTemplateGetMasterForm.id,
    });

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <GaiaPageLayoutColumn>
            {masterForm && (
                <GaiaPageComponent title={t(`masterFormRoute.${masterFormType}FormTitle`)}>
                    {error && <Alert severity="error">{error.message}</Alert>}
                    <FormTemplateEditor
                        formTemplateQuestions={masterForm?.settingsFormTemplateGetMasterForm.questions}
                        onAddQuestion={handleAddQuestion}
                        onUpdateQuestion={handleUpdateQuestion}
                        onDeleteQuestion={async id =>
                            await deleteFormTemplateQuestionMutation.deleteFormTemplateQuestion(id)
                        }
                        isAddQuestionLoading={addFormTemplateQuestionMutation.loading}
                        isUpdateQuestionLoading={updateFormTemplateQuestionMutation.loading}
                        isDeleteQuestionLoading={deleteFormTemplateQuestionMutation.loading}
                        addQuestionError={addFormTemplateQuestionMutation.error}
                        editQuestionError={editQuestionError}
                    />
                </GaiaPageComponent>
            )}
        </GaiaPageLayoutColumn>
    );
}
